import script from "./RoomTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomTopComponent.vue?vue&type=style&index=0&id=3b918348&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b918348"]])

export default __exports__